
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const NooverspeedActions = (props) => {
    const handleOverspeedClick = (e) => {
        e.stopPropagation();
        props.context.componentParent.onShowOverspeedKpi(0);
    };
    

    return (
        <div>
			<button onClick={handleOverspeedClick} className="custom-btn f22 label label-success" title="Overspeed" style={{color:"#ccc"}}><i className="fa fa-tachometer"></i> &nbsp;</button>
            
        </div>
    );
};

export default NooverspeedActions;
